// Translation provided by Vuetify (typescript)
import en from 'vuetify/es5/locale/en';

export default {
  $vuetify: {
    ...en,
  },

  common: {
    days: 'Days',
    startTime: 'Start Time',
    endTime: 'End Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    save: 'Save',
    update: 'Update',
    precision: 'Precision',
    series: 'Series',
  },

  time: {
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    month: 'Month',
  },

  lang: {
    en: 'English',
    es: 'Spanish',
  },

  footer: {
    copyright: 'Copyright',
  },

  profile: {
    copyright: 'Copyright',
    validateMetrcAccess: 'Validate Metrc Access',
    uploadPhoto: 'Upload Photo',
    changePassword: 'Change Password',
    profile: 'Profile',
    workHours: 'Work Hours',
    scheduledAbsences: 'Scheduled Absences',
    facilityAccess: 'Facility Access',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'E-mail',
    position: 'Position',
    assignedRoles: 'Assigned Role(s)',
    notificationMethod: 'Notification Method',
    cellPhone: 'Cell Phone',
    defaultView: 'defaultView',
    metrcApiKey: 'Metrc API Key',
    userPreferences: 'User Preferences',
    defaultChart: 'Default Chart',
    preferredVFUStateInteraction: 'Preferred VFU State Interaction',
    defaultDeviceDashboardView: 'Default Device Dashboard View',
    useTwoFactorAuthentication: 'Use two-factor authentication',
    'full-unit-name': 'Show Full VFU Name',
    useVFULegacyView: 'Use VFU Legacy View',
    metric: 'Metric',
    imperial: 'Imperial',
    localTime: 'Local Time',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    '12HourTime': '12 Hour Time',
    '24HourTime': '24 Hour Time',
  },

  workHours: {
    addWorkDays: 'Add Work Days',
    editWorkDays: 'Edit Work Days',
    editWorkDay: 'Edit Work Day',
    deleteWorkDay: 'Delete Work Day',
  },

  device: {
    currentState: 'Current State',
    environment: 'Environment',
    photo: 'Photo',
    manualControl: 'Manual Control',
    schedules: 'Schedules',
    deviceLogs: 'Device Logs',
    controlLoops: 'Control Loops',
    lifecycles: 'Lifecycles',
    lifecycleTasks: 'Lifecycle Tasks',
    IPMScouting: 'IPMScouting',
    healthReports: 'Health Reports',
    zones: 'Zones',
    serviceHistory: 'Service History',
  },
};
